#import '../../../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql'

mutation DeleteTask($input: TaskDeleteInput!) {
    taskDelete(input: $input) {
        task {
            ...CoreEntityTaskFragment
        }
    }
}
